export interface TranslationItem {
  id: string;
  en: string;
  se?: string;
}

export class TranslationItemClass implements TranslationItem {
  id: string;
  en: string;
  se?: string | undefined;

  constructor(o: any = {}) {
    this.id = o['id'] ?? null;
    this.en = o['en'] ?? null;
    this.se = o['se'] ?? null;
  }
}

export interface Translation {
  id: string;
  translations: TranslationItem[];
}

export class TranslationClass implements Translation {
  id: string;
  translations: TranslationItem[];

  constructor(o: any = {}) {
    this.id = o['id'] ?? null;
    const translations = o[this.id] ? o[this.id] : o['translations'];
    this.translations = translations.map((item: any) => {
      return new TranslationItemClass(item);
    });
  }
}
